/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { DecimalPipe, PercentPipe, CurrencyPipe } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { ModalTooltipComponent } from './components/modal-tooltip/modal-tooltip.component';
import { DynamicFormCardComponent } from './components/dynamic-form-card/dynamic-form-card.component';
import { PopoverTooltipComponent } from './components/popover-tooltip/popover-tooltip.component';
import { DynamicInputComponent } from './components/dynamic-input/dynamic-input.component';
import { TimedButtonComponent } from './components/timed-button/timed-button.component';
import { SkeletonItemComponent } from './components/skeleton-item/skeleton-item.component';
import { SpinnerCircleComponent } from './components/spinner-circle/spinner-circle.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ModalPrefaceComponent } from './components/modal-preface/modal-preface.component';
import { ModalPrefaceStepsComponent } from './components/modal-preface-steps/modal-preface-steps.component';
import { AmountCounterComponent } from './components/amount-counter/amount-counter.component';
import { QuotationPreviewComponent } from './components/quotation-preview/quotation-preview.component';
import { FormsModule } from '@angular/forms';
import { DomainFilterPipe } from './pipes/domain-filter/domain-filter.pipe';
import { DomainValuePipe } from './pipes/domain-value/domain-value.pipe';
import { ModalSearchComponent } from './components/modal-search/modal-search.component';
import { IonicModule } from '@ionic/angular';
import { StepHeaderComponent } from './components/step-header/step-header.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IfDemoDirective } from './directives/if-demo/if-demo.directive';
import { WizardWidgetComponent } from './components/wizard-widget/wizard-widget.component';
import { ModalMessagesComponent } from './components/modal-messages/modal-messages.component';
import { ModalStateComponent } from './components/modal-state/modal-state.component';
import { FullIframeComponent } from './components/full-iframe/full-iframe.component';
import { EmptyPlaceholderComponent } from './components/empty-placeholder/empty-placeholder.component';
import { EmptyPlaceholderCardComponent } from './components/empty-placeholder-card/empty-placeholder-card.component';
import { RetryAfterErrorComponent } from './components/retry-after-error/retry-after-error.component';
import { FileButtonComponent } from './components/file-button/file-button.component';
import { FileButtonCircleComponent } from './components/file-button-circle/file-button-circle.component';
import { IntNumberPipe } from './pipes/int-number/int-number.pipe';
import { DecimalNumberPipe } from './pipes/decimal-number/decimal-number.pipe';
import { UseProgressBarComponent } from './components/use-progress-bar/use-progress-bar.component';
import { DetailRowComponent } from './components/detail-row/detail-row.component';
import { DynamicNumberPipe } from './pipes/dynamic-number/dynamic-number.pipe';
import { IfDriverDirective } from './directives/if-driver/if-driver.directive';
import { SrcAssetsPipe } from './pipes/src-assets/src-assets.pipe';
import { BulletListComponent } from './components/bullet-list/bullet-list.component';
import { IconPipe } from './pipes/icon/icon.pipe';
import { TipCardComponent } from './components/tip-card/tip-card.component';
import { IfViewDirective } from './directives/if-view/if-view.directive';
import { FullscreenComponent } from './components/fullscreen/fullscreen.component';
import { IfLinkDirective } from './directives/if-link/if-link.directive';
import { AriaLabelPipe } from './pipes/aria-label/aria-label.pipe';
import { AriaButtonDirective } from './directives/aria-button/aria-button.directive';
import { AriaImageDirective } from './directives/aria-image/aria-image.directive';
import { AriaValuePipe } from './pipes/aria-value/aria-value.pipe';
import { AriaSelectDirective } from './directives/aria-select/aria-select.directive';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ProgressLoaderComponent } from './components/progress-loader/progress-loader.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    StepHeaderComponent,
    ModalSearchComponent,
    ModalPrefaceComponent,
    ModalPrefaceStepsComponent,
    QuotationPreviewComponent,
    AmountCounterComponent,
    SpinnerComponent,
    SpinnerCircleComponent,
    SkeletonItemComponent,
    TimedButtonComponent,
    PopoverTooltipComponent,
    ModalTooltipComponent,
    ModalMessagesComponent,
    DynamicFormCardComponent,
    DynamicInputComponent,
    AlertMessageComponent,
    WizardWidgetComponent,
    FullIframeComponent,
    ModalStateComponent,
    EmptyPlaceholderComponent,
    EmptyPlaceholderCardComponent,
    RetryAfterErrorComponent,
    FileButtonComponent,
    FileButtonCircleComponent,
    FooterComponent,
    DomainValuePipe,
    DomainFilterPipe,
    IfDemoDirective,
    IfDriverDirective,
    IfViewDirective,
    IntNumberPipe,
    DecimalNumberPipe,
    UseProgressBarComponent,
    DetailRowComponent,
    DynamicNumberPipe,
    SrcAssetsPipe,
    BulletListComponent,
    IconPipe,
    AriaLabelPipe,
    TipCardComponent,
    FullscreenComponent,
    IfLinkDirective,
    AriaButtonDirective,
    AriaImageDirective,
    AriaValuePipe,
    AriaSelectDirective,
    ProgressLoaderComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    NgCircleProgressModule,
    NgCircleProgressModule.forRoot()
  ],
  exports: [
    StepHeaderComponent,
    ModalSearchComponent,
    ModalPrefaceComponent,
    ModalPrefaceStepsComponent,
    QuotationPreviewComponent,
    AmountCounterComponent,
    SpinnerComponent,
    SpinnerCircleComponent,
    SkeletonItemComponent,
    TimedButtonComponent,
    PopoverTooltipComponent,
    ModalTooltipComponent,
    ModalMessagesComponent,
    DynamicFormCardComponent,
    DynamicInputComponent,
    AlertMessageComponent,
    WizardWidgetComponent,
    FullIframeComponent,
    ModalStateComponent,
    EmptyPlaceholderComponent,
    EmptyPlaceholderCardComponent,
    RetryAfterErrorComponent,
    FileButtonComponent,
    FileButtonCircleComponent,
    FooterComponent,
    DomainValuePipe,
    DomainFilterPipe,
    TranslateModule,
    IfDemoDirective,
    IfDriverDirective,
    IfViewDirective,
    IntNumberPipe,
    DynamicNumberPipe,
    DecimalNumberPipe,
    UseProgressBarComponent,
    DetailRowComponent,
    SrcAssetsPipe,
    BulletListComponent,
    IconPipe,
    AriaLabelPipe,
    TipCardComponent,
    FullscreenComponent,
    IfLinkDirective,
    AriaButtonDirective,
    AriaImageDirective,
    AriaValuePipe,
    AriaSelectDirective,
    ProgressLoaderComponent
  ],
  providers: [
    DecimalPipe,
    PercentPipe,
    CurrencyPipe,
    SrcAssetsPipe,
    IconPipe,
    AriaLabelPipe,
    DynamicNumberPipe
  ]
})
export class SharedModule {}
